<div class="login-wrapper">
  <div class="login-container">
    <!-- Login Card -->
    <div class="login-card" [class.loading-state]="loading">
      <!-- Company Logo -->
      <div class="logo-section">
        <!-- Light theme logo -->
        <img 
          src="https://r2.hamel.construction/P06750_Hamel_Construction_Logo_RGB.png" 
          alt="Hamel Construction Logo" 
          class="company-logo light-logo"
        />
        <!-- Dark theme logo -->
        <img 
          src="https://r2.hamel.construction/P06750_Hamel_Construction_Logo_W.png" 
          alt="Hamel Construction Logo" 
          class="company-logo dark-logo"
        />
        <p class="welcome-subtitle">
          Système Intégré Hamel Construction
        </p>
      </div>

      <!-- Login Content -->
      <div class="login-content">
        <!-- Azure SSO Login Button -->
        <div class="sso-login">
          <button 
            class="login-button"
            (click)="signInWithAzure()"
            [disabled]="loading"
            type="button"
          >
            <span class="button-icon"><i class="pi pi-sign-in"></i></span>
            <span class="button-text">{{ loading ? 'Redirection vers Azure AD...' : 'Se connecter' }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <div class="login-footer">
      <p class="footer-text">
        © 2024 Hamel Construction. Tous droits réservés.
      </p>
    </div>
  </div>

  <!-- Toast Messages Container -->
  <div id="toast-container" class="toast-container"></div>
</div>
